import React from 'react';
import { useTranslation } from 'react-i18next';
import { BrowseSwitcherLink, PageSwitcherTypes } from '@app/router';
import { EVENTS, trackEvent } from '@app/segment';
import { VERTICALS_ARR } from '@app/config';
import buildUrl from './utils/buildUrl';

const NavLink = ({
  category,
  ordinal,
  parentCategory,
  urlPrefix,
  languageCode,
}) => {
  const { t } = useTranslation();
  const { id, url, name } = category;
  const categoryName =
    languageCode === 'ja' && name === 'City' ? 'brand_style_city' : name;

  return (
    <BrowseSwitcherLink
      key={id}
      data-testid={`navbar-menu-browse-submenu-${categoryName?.toLowerCase()}`}
      updatedVertical={
        VERTICALS_ARR.includes(categoryName) && categoryName.toLowerCase()
      }
      onClick={() => {
        trackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
          label: categoryName,
        });
      }}
      to={{
        pathname: `${urlPrefix}${buildUrl(url, ordinal, parentCategory)}`,
        state: {
          as: PageSwitcherTypes.Browse,
        },
      }}
    >
      {t(categoryName)}
    </BrowseSwitcherLink>
  );
};

export default NavLink;
